import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Add User ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" id ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" email ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" token ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" name ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" last name ")
const _hoisted_7 = /*#__PURE__*/_createVNode("button", null, "add", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" --- ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("form", {
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addUser && _ctx.addUser(...args)), ["prevent"]))
    }, [
      _createVNode("label", null, [
        _hoisted_2,
        _withDirectives(_createVNode("input", {
          type: "number",
          class: "input mb-4",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.id = $event))
        }, null, 512), [
          [_vModelText, _ctx.id]
        ])
      ]),
      _createVNode("label", null, [
        _hoisted_3,
        _withDirectives(_createVNode("input", {
          type: "email",
          class: "input mb-4",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.email = $event))
        }, null, 512), [
          [_vModelText, _ctx.email]
        ])
      ]),
      _createVNode("label", null, [
        _hoisted_4,
        _withDirectives(_createVNode("input", {
          type: "text",
          class: "input mb-4",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.token = $event))
        }, null, 512), [
          [_vModelText, _ctx.token]
        ])
      ]),
      _createVNode("label", null, [
        _hoisted_5,
        _withDirectives(_createVNode("input", {
          type: "text",
          class: "input mb-4",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.firstName = $event))
        }, null, 512), [
          [_vModelText, _ctx.firstName]
        ])
      ]),
      _createVNode("label", null, [
        _hoisted_6,
        _withDirectives(_createVNode("input", {
          type: "text",
          class: "input mb-4",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.lastName = $event))
        }, null, 512), [
          [_vModelText, _ctx.lastName]
        ])
      ]),
      _hoisted_7
    ], 32),
    _hoisted_8
  ], 64))
}